import { Immutable } from "immer";
import { useState } from "react";
import { UseFormReturn } from "react-hook-form";

import { Button } from "@/components/ui/button";
import {
    BlockEdit,
    FeatureFlagButton,
    FeatureFlagModalWrapper,
} from "@/routes/layouts/components/Sidebar";
import { LayoutEditDispatch, LayoutEditState } from "@/routes/layouts/layoutEditState";
import { TournamentLayoutMetadata } from "@/routes/tournament/TournamentLayoutDetailRoute";

import { TournamentMetadataForm } from "./TournamentMetadataForm";

export const TournamentLayoutEditSidebar = ({
    state,
    dispatch,
    metadataForm,
    onSubmit,
}: {
    state: Immutable<LayoutEditState>;
    dispatch: LayoutEditDispatch;
    metadataForm: UseFormReturn<TournamentLayoutMetadata>;
    onSubmit: () => void;
}) => {
    const activeBlock = state.activeBlock;
    const [featureFlagModalOpen, setFeatureFlagModalOpen] = useState(false);

    return (
        <div className="m-2 flex flex-grow basis-1 flex-col gap-4">
            <div className="sticky top-0">
                {activeBlock ? (
                    <div className="max-h-[100vh] space-y-4 overflow-auto py-4">
                        <div className="flex gap-4">
                            <div className="flex flex-1 gap-2">
                                <Button
                                    onClick={() => {
                                        dispatch({ type: "duplicate-block", blockId: activeBlock });
                                    }}
                                    variant="outline"
                                >
                                    Duplicate block
                                </Button>
                                <Button
                                    onClick={() => {
                                        dispatch({
                                            type: "delete-block",
                                            blockId: activeBlock,
                                        });
                                    }}
                                    variant="destructive"
                                >
                                    Delete block
                                </Button>
                            </div>

                            <FeatureFlagButton
                                blockId={activeBlock}
                                state={state}
                                onClick={() => setFeatureFlagModalOpen(true)}
                            />
                        </div>
                        <BlockEdit blockId={activeBlock} state={state} key={activeBlock} />
                        <FeatureFlagModalWrapper
                            blockId={activeBlock}
                            state={state}
                            open={featureFlagModalOpen}
                            onSave={onSubmit}
                            onOpenChange={setFeatureFlagModalOpen}
                        />
                    </div>
                ) : (
                    <TournamentMetadataForm form={metadataForm} onSubmit={onSubmit} />
                )}
            </div>
        </div>
    );
};
